import { DocsIcon, ExcelIcon, FailedIcon, SuccessIcon } from '@assets/icons';
import { Box, Button, Divider, Flex, HStack, Text, Tooltip, useClipboard, VStack } from '@chakra-ui/react';
import { useSnackbarNotification } from '@store/snackbarNotification';
import moment from 'moment';
import Cookies from 'universal-cookie';

export default function PostUploadModal({
    modalTitle = 'Modal Title',
    isSuccess = false,
    fileName = 'Parahub-12 Jan 2025 [Edited].xlsx',
    onClose = () => {},
    onDownload = () => {},
    detailMessages = [],
}) {
    const { onCopy, setValue, hasCopied } = useClipboard('');
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    const Icon = isSuccess ? SuccessIcon : FailedIcon;
    const modalTitleColor = isSuccess ? 'success.500' : 'danger.500';

    const timestamp = moment().locale('id').format('DD MMMM YYYY - HH:mm:ss [WIB]');
    const cookies = new Cookies();
    const username = cookies.get('username');
    const email = cookies.get('email') ?? '-';

    const handleCopy = () => {
        setValue(detailMessages);
        onCopy();
        onChangeSnackbarNotification({
            status: 'success',
            description: `Detail ${isSuccess ? 'Update' : 'Masalah'} Berhasil di salin!`,
            duration: 3,
        });
    };

    return (
        <Box textAlign="center">
            <VStack mb={'16px'}>
                <Icon withBotShadow />

                <HStack gap="8px" p="12px 16px" bg="semantic.200" borderRadius="full" mb="12px">
                    <ExcelIcon />
                    <Text fontSize="14px" fontWeight={700} color="semantic.500">
                        {fileName}
                    </Text>
                </HStack>
                <Text color={modalTitleColor} fontSize="24px" fontWeight="600">
                    {modalTitle}
                </Text>
            </VStack>

            <Box bg="#F8F9FD" borderRadius="8px" p="16px" mb="16px">
                <HStack justify="space-between" mb="12px">
                    <Text fontWeight="700">{isSuccess ? 'Detail Update' : 'Detail Masalah'}</Text>
                    <Tooltip
                        hasArrow
                        label={hasCopied ? 'Copied!' : 'Copy'}
                        bg="semantic.900"
                        color="semantic.100"
                        placement="top"
                    >
                        <Box cursor={'pointer'} onClick={handleCopy}>
                            <DocsIcon />
                        </Box>
                    </Tooltip>
                </HStack>

                <Box p="16px" textAlign="left" bg={isSuccess ? 'success.100' : 'danger.100'} borderRadius="8px">
                    {!isSuccess && (
                        <Text fontSize="12px" fontWeight="700" color="danger.600" mb="8px">
                            {detailMessages.length} Kesalahan File Ditemukan
                        </Text>
                    )}

                    <Box px={!isSuccess ? '12px' : '0'}>
                        {(Array.isArray(detailMessages) ? detailMessages : [detailMessages]).map((msg, i, arr) => {
                            const Icon = isSuccess ? SuccessIcon : FailedIcon;
                            const isLast = i === arr.length - 1;

                            return (
                                <Flex key={i} mb={isLast ? 0 : '8px'} alignItems="center">
                                    <Box mt="1px">
                                        <Icon size={16} />
                                    </Box>
                                    <Text ml="8px" fontSize="14px">
                                        {msg}
                                    </Text>
                                </Flex>
                            );
                        })}
                    </Box>
                </Box>

                <Divider my="16px" />

                <Flex direction="column" gap="8px">
                    {[
                        ['Tanggal/Waktu Upload', timestamp],
                        ['Username', username],
                        ['Email', email],
                    ].map(([label, value]) => (
                        <Flex key={label} justify="space-between">
                            <Text color="neutral.500" fontSize="14px">
                                {label}
                            </Text>
                            <Text color="semantic.500" fontSize="14px">
                                {value}
                            </Text>
                        </Flex>
                    ))}
                </Flex>
            </Box>

            {!isSuccess && (
                <Text fontWeight="400" fontSize="14px" mb="12px">
                    Klik Download untuk melihat detail kesalahan di dalam file
                </Text>
            )}

            <Flex justify="center" gap="12px">
                <Button variant="outline" px="32px" onClick={onClose}>
                    Tutup
                </Button>
                {!isSuccess && <Button onClick={onDownload}>Download</Button>}
            </Flex>
        </Box>
    );
}
